import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";
import { RootState } from "store/Store";

export interface PilotsReducerState {
  pilotList: any[]
  selectedPilotId: string
}

// Get persisted selected pilot ID from localStorage
const getPersistedSelectedPilotId = (): string => {
  try {
    return localStorage.getItem('selectedPilotId') || '';
  } catch {
    return '';
  }
};

const defaultState: PilotsReducerState = {
  pilotList: [],
  selectedPilotId: getPersistedSelectedPilotId(),
}

export const pilotsSlice = createSlice({
  name: 'pilots',
  initialState: defaultState,
  reducers: {
    setPilotList: (state, action: PayloadAction<any>) => {
      state.pilotList = action.payload;
      // Only set default pilot if no pilot is currently selected
      if (!state.selectedPilotId && state.pilotList.length > 0) {
        state.selectedPilotId = state.pilotList[0]?.projectId;
        // Persist the selected pilot ID
        try {
          localStorage.setItem('selectedPilotId', state.selectedPilotId);
        } catch {
          // Ignore localStorage errors
        }
      }
    },
    updatePilotList: (state, action: PayloadAction<any>) => {
      state.pilotList = action.payload;
      // Don't change selectedPilotId and selectedPilotDocId when updating
    },
    selectPilot: (state, action: PayloadAction<{ projectId: string }>) => {
      state.selectedPilotId = action.payload.projectId || '';
      // Persist the selected pilot ID
      try {
        localStorage.setItem('selectedPilotId', state.selectedPilotId);
      } catch {
        // Ignore localStorage errors
      }
    },
    clearSelectedPilot: (state) => {
      state.selectedPilotId = '';
      // Clear the persisted pilot ID
      try {
        localStorage.removeItem('selectedPilotId');
      } catch {
        // Ignore localStorage errors
      }
    }
  }
}) as any;

export const {
  setPilotList,
  updatePilotList,
  selectPilot,
  clearSelectedPilot
} = pilotsSlice.actions;

export const selectPilotList = (state: RootState) => (state.pilots as PilotsReducerState).pilotList;
export const selectSelectedPilotId = (state: RootState) => (state.pilots as PilotsReducerState).selectedPilotId;
